import { Injectable } from '@angular/core';

import { ShAutocompleteService } from '../../core/autocomplete/services/autocomplete.service';

@Injectable({ providedIn: 'root' })
export class ShTaskAutocompleteDataService extends ShAutocompleteService {
    protected readonly ENDPOINT: string = `workflow/api/tasks/autocomplete/`;
}
